module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contacto"
    }
  }, [_c('div', {
    staticClass: "container-fluid cornered",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "row contact-container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.state.title))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "data-aos": "fade-in"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.state.subTitle1))]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST",
      "action": "~/../../../../send-mail.php"
    }
  }, [_c('input', {
    attrs: {
      "name": "nombre",
      "placeholder": "Nombre",
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "email",
      "placeholder": "Correo",
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "asunto",
      "placeholder": "Asunto",
      "type": "text"
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "placeholder": "Mensaje",
      "name": "mensaje",
      "id": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "transform": "skew(10deg)"
    }
  }, [_c('button', {
    staticStyle: {
      "background-color": "#d51218",
      "color": "white",
      "border": "0px",
      "padding": "10px",
      "width": "80px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.warn('Mensaje Enviado.', $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.state.btnSubmit))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "data-aos": "fade-in"
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.state.subTitle2))]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3359.0345365373037!2d-115.37697558431404!3d32.658525081008065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d7722962be5925%3A0x842c3f832fa84681!2sCalzada+Abelardo+L+Rodriguez+829%2C+Pob+Compuertas%2C+Mexicali%2C+B.C.!5e0!3m2!1ses!2smx!4v1495037701479",
      "width": "300",
      "height": "250",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "data-aos": "fade-in"
    }
  }, [_c('h3', [_vm._v("México")]), _vm._v(" "), _c('p', [_vm._v("Blvd. Abelardo L. Rodríguez #829\n          "), _c('br'), _vm._v(" Col. Plutarco Elías Calles, C.P. 21376\n          "), _c('br'), _vm._v(" Mexicali, Baja California\n          "), _c('br'), _vm._v(" (686) 841 6100 al 03\n          "), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("E.U.A")]), _vm._v(" "), _c('p', [_vm._v("Santoyo Transport LLC\n          "), _c('br'), _vm._v(" 2310 Martin Luther King JR Ave.\n          "), _c('br'), _vm._v(" Calexico, Ca. 92231\n          "), _c('br'), _vm._v(" contacto@transportessantoyo.com\n          "), _c('br'), _vm._v(" (760) 690 3629\n          "), _c('br'), _vm._v(" Yolanda López Gastelum\n          "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e040aa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/ContactoPage.vue
// module id = 149
// module chunks = 0